import Rive from "@rive-app/react-canvas";

export const UnlikelyAISpinner = () => <Rive src="spinner.riv" />;
